import {FormControl, NavigateWithoutBlocker} from 'platform/components';

import {ReactNode} from 'react';
import {useFormState} from 'react-hook-form';

import {isNil} from 'ramda';

import {VehicleFinancingTemplateFormValues} from '../schemas/vehicleFinancingTemplateFormSchema';
import {VehicleFinancingTemplateFormFooterState} from '../types/VehicleFinancingTemplateFormFooterState';

interface VehicleFinancingTemplateFormFooterSlotProps {
  control: FormControl<VehicleFinancingTemplateFormValues>;
  navigateWithoutBlocker: NavigateWithoutBlocker;
  isOptionsLoading: boolean;
  discard: VoidFunction;
  renderFooter?: (state: VehicleFinancingTemplateFormFooterState) => ReactNode;
}

/**
 * Renders the host's footer with a live saving state.
 *
 * The `useFormState` subscription lives in this leaf on purpose: reading `formState` in the
 * component that owns `useForm()` registers a root subscription and re-renders the whole form
 * tree on every state transition.
 */
export function VehicleFinancingTemplateFormFooterSlot(
  props: VehicleFinancingTemplateFormFooterSlotProps
) {
  const {isSubmitting} = useFormState({control: props.control});

  if (isNil(props.renderFooter)) {
    return null;
  }

  return (
    <>
      {props.renderFooter({
        control: props.control,
        navigateWithoutBlocker: props.navigateWithoutBlocker,
        isSaving: isSubmitting,
        isOptionsLoading: props.isOptionsLoading,
        discard: props.discard,
      })}
    </>
  );
}
